import * as React from "react";
import { CreateSvgIcon } from "../icon";
import { IconNames, IconProps } from "../names";

export const Dash = (props: IconProps) => (
  <CreateSvgIcon {...props} data-cy={IconNames.Dash}>
    {({ color }) => <path fill={color} d="M7 15h18v2H7z" />}
  </CreateSvgIcon>
);
